import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature98',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page feature98-page',
    },
    bg: {
      className: 'bg',
      children:
        'https://imm.86links.com/assets/landing/feature/template/feature98-bg.png',
    },
    childWrapper: {
      className: 'feature98-title-wrapper',
      children: [
        {
          name: '标题',
          children: '新经济',
          className: 'feature98-title',
        },
      ],
    },
    content: {
      className: 'feature98-content',
      children: [
        {
          name: '项目0',
          className: 'c1',
          children: [
            {
              name: '图标',
              className: 'icon icon1',
              children:
                'https://imm.86links.com/assets/landing/feature/template/feature98-icon1.png',
            },
            {
              name: '内容',
              className: 'text text1',
              children:
                '聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。',
            },
          ],
        },
        {
          name: '项目1',
          className: 'c2',
          children: [
            {
              name: '图标',
              className: 'icon icon2',
              children:
                'https://imm.86links.com/assets/landing/feature/template/feature98-icon2.png',
            },
            {
              name: '内容',
              className: 'text text2',
              children:
                '汽车+新经济创新产业园""哈工大智能经济产业园"汽车智创活力港等新经济发展载体10余家，科创新经济走廊"逐步形成。',
            },
          ],
        },
      ],
    },
    image: {
      className: 'feature98-image',
      children:
        'https://imm.86links.com/assets/landing/feature/template/feature98-right.png',
    },
  },
};
